import { WidgetCustomizationsState } from './types'

export const widgetState: WidgetCustomizationsState = {
  customizations: {
    isReadOnly: false,
    isPreview: false,
    isLaunched: false,
    isDresser: false,
    livePreview: {
      show: false,
      widgetMarkingStrategy: '',
      topBar: {
        headerText: '',
        helpText: '',
        backgroundColor: '',
        backgroundOpacity: 0,
        fontColor: '',
        ctaLinkPath: '',
        ctaText: '',
        closeButtonTextColor: '',
        closeButtonBackgroundColor: '',
        closeButtonText: ''
      }
    },
    isDummy: false,
    autoPickOptionIndex: 0,
    oneTimeAtLast: false,
    productHandle: '',
    storefrontTheme: '',
    buyOnceText: '',
    showGetItText: false,
    getItText: '',
    sellingPlans: {
      showDiscount: true,
      sort: {
        strategy: 'name'
      }
    },
    tiles: {
      borderColor: '',
      borderStyle: '',
      borderSize: '',
      backgroundColor: '',
      fontColor: '',
      fullPriceText: '',
      suffixText: '',
      tileHeight: '',
      oddSpread: false
    },
    selectionType: '',
    autoInject: {
      enabled: false,
      targetSelector: '',
      adjacentStrategy: 'beforebegin'
    },
    fullFormatProductPrice: '',
    priceLabel: {
      prefix: '',
      strategy: 'starting_and_actual',
      percentSymbolLocation: 'right'
    },
    subscriptionPolicy: {
      shouldShow: false,
      description: '',
      footer: '',
      informationLink: ''
    },
    styles: {
      notSelectedRadio: {
        backgroundColor: ''
      },
      selectedRadio: {
        borderColor: '',
        borderStyle: '',
        borderSize: '',
        backgroundColor: '',
        backgroundImageUrl: '',
        dropdownBorderColor: '',
        dropdownBackgroundColor: '',
        dropdownHoverColor: '',
        openByDefault: true
      },
      radioButton: {
        innerColor: '',
        outerColor: ''
      },
      fontFamily: {
        name: '',
        weight: '',
        url: ''
      },
      fontSize: {
        primary: '',
        sellingPlans: {
          name: '',
          options: ''
        }
      },
      colors: {
        text: {
          primary: ''
        }
      }
    },
    hooks: {
      widgetReady: '',
      sellingPlanChanged: ''
    }
  }
}
